import { Exclude, Expose } from '@nts/std/serialization';
import { ServiceRequest } from './service-request';
import { GenericServiceRequestInterface } from '@nts/std/interfaces';

@Exclude()
export class GenericServiceRequest<TRequestData> extends ServiceRequest implements GenericServiceRequestInterface<TRequestData> {

    @Expose()
    requestData: TRequestData;
}
